import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-3" }
const _hoisted_2 = { class: "py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SongsCounter = _resolveComponent("SongsCounter")!
  const _component_CategoryFilter = _resolveComponent("CategoryFilter")!
  const _component_BandFilter = _resolveComponent("BandFilter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SongsCounter),
    _createVNode(_component_CategoryFilter),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BandFilter)
    ])
  ]))
}